/**
 * Axis and series defaults for charts that count things (sign-ups, sends, candidates).
 *
 * Counts are whole numbers, so their value axis must not print "0.5" or "2.5" ticks, which it did
 * whenever a series was small. And a daily count joined by the default smoothed curve implies
 * values between days that never existed; straight segments between points are the honest line.
 */
export const COUNT_Y_AXIS = [{ tickMinStep: 1 }];

/** Straight segments between points, for series of per-day or per-period counts. */
export const linearSeries = <T extends object>(series: T[]): (T & { curve: 'linear' })[] =>
  series.map((s) => ({ ...s, curve: 'linear' as const }));
